import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import riwaStore from './App/Utils/appStore';
import { RouterProvider } from 'react-router-dom';
import appRouter from './App/appRouter';
import ErrorBoundary from './Modules/Screens/ErrorScreen/ErrorBoundary';
import { AuthProvider } from "react-oidc-context";

const cognitoAuthConfig = {
  authority: process.env.REACT_APP_SSO_AUTHORITY,
  client_id: process.env.REACT_APP_SSO_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_SSO_REDIRECT,
  response_type: "code",
  scope: "email openid phone",
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  //<React.StrictMode>
    <Provider store={riwaStore}>
      <ErrorBoundary>
        <AuthProvider {...cognitoAuthConfig}>
          <RouterProvider router={appRouter} />
        </AuthProvider>
      </ErrorBoundary>
    </Provider>
  //</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
